import { getClient } from '@/api/api-client';
import type { IInvestorInfo, IMonthlyInvestorShareFilterOptions } from '@condo/domain';
import { type IMonthlyInvestorShare, type IPaginatedResponse, InvestorInfo } from '@condo/domain';
import type {
    FindInvestorShareIdsQueryParams,
    FindInvestorShareIdsQueryResponse,
    GenerateInvestorPayoutStatementMutationRequest,
    GenerateInvestorPayoutStatementMutationResponse,
    GetMonthlyInvestorShareByIdQueryParams,
    GetMonthlyInvestorShareByIdQueryResponse,
    GetMonthlyInvestorShareStatsQueryParams,
    GetMonthlyInvestorShareStatsQueryResponse,
} from '@condo/sdk/propx';

export const getMonthlyInvestorShare = async (
    query?: IMonthlyInvestorShareFilterOptions,
): Promise<IPaginatedResponse<IMonthlyInvestorShare, 'investorShares'>> => {
    return getClient('basecamp')
        .get('/investor-share', { params: query })
        .then(({ data }) => {
            return {
                investorShares: data.investorShares.map((iinfo: IMonthlyInvestorShare) => {
                    return { ...iinfo, investorInfo: new InvestorInfo(iinfo.investorInfo as IInvestorInfo) };
                }),
                pagination: data.pagination,
            };
        });
};

export const getMonthlyInvestorShareIds = async (params: FindInvestorShareIdsQueryParams): Promise<FindInvestorShareIdsQueryResponse> =>
    getClient('propx').findInvestorShareIds(params);

export const getMonthlyInvestorShareById = async (
    monthlyInvestorShareId: number,
    opts?: GetMonthlyInvestorShareByIdQueryParams,
): Promise<GetMonthlyInvestorShareByIdQueryResponse> => getClient('propx').getMonthlyInvestorShareById({ monthlyInvestorShareId }, opts);

export const getMonthlyInvestorShareStats = async (params: GetMonthlyInvestorShareStatsQueryParams): Promise<GetMonthlyInvestorShareStatsQueryResponse> =>
    getClient('propx').getMonthlyInvestorShareStats(params);

export const generateInvestorPayoutStatement = async (
    monthlyInvestorShareId: number,
    data?: GenerateInvestorPayoutStatementMutationRequest,
): Promise<GenerateInvestorPayoutStatementMutationResponse> => getClient('propx').generateInvestorPayoutStatement({ monthlyInvestorShareId }, data);
